import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import xamaLogoazul from '../../assets/logos/xama-logo-azul.png';
import StepNIcheAndObjective from '../FastPublishing/stepNicheAndObjective';
import StepColorPalette from '../FastPublishing/stepColorPalette';
import StepTypography from '../FastPublishing/stepTypography';
import StepLogo from '../FastPublishing/stepLogo';
import styles from '../FastPublishing/styles.module.css';

const STEPS = {
  STEP_PASS_NICHE_AND_OBJECTIVE: 'stepNIcheAndObjective',
  STEP_PASS_COLOR_PALETTE: 'StepColorPalette',
  STEP_PASS_TYPOGRAPHY: 'stepTypography',
  STEP_PASS_LOGO: 'stepLogo',
};

function FastPublishing1() {
  const [step, setStep] = useState(STEPS.STEP_PASS_NICHE_AND_OBJECTIVE);
  const { t } = useTranslation();

  const [businessAccountData, setBusinessAccountData] = useState('');
  const [objectiveSelected, setObjectiveSelected] = useState({
    label: 'Engagement',
    value: 0,
  });
  const [colors, setColors] = useState([]);
  const [font, setFont] = useState('');
  const [logoSelectedArray, setLogoSelectedArray] = useState([]);
  const changesStep = useRef(false);

  useEffect(() => {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = () => window.location.reload();
  }, []);

  const ProgressBar = () => {
    let stepNumber = 0;
    let stepName = '';

    switch (step) {
    case STEPS.STEP_PASS_NICHE_AND_OBJECTIVE:
      stepNumber = 1;
      stepName = t('fast_publishing_niche_and_objective');
      break;
    case STEPS.STEP_PASS_COLOR_PALETTE:
      stepNumber = 2;
      stepName = t('fast_publishing_color_palette');
      break;
    case STEPS.STEP_PASS_TYPOGRAPHY:
      stepNumber = 3;
      stepName = t('fast_publishing_typography');
      break;
    case STEPS.STEP_PASS_LOGO:
      stepNumber = 4;
      stepName = t('fast_publishing_logo');
      break;
    default:
      break;
    }

    if (stepNumber === 0) {
      return null;
    }

    return (
      <div
        style={{
          width: '100%',
          maxWidth: '600px',
          margin: '16px auto',
          padding: '0 16px',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '16px',
            position: 'relative',
          }}
        >
          <span
            style={{
              color: '#857c8c',
              fontSize: '16px',
              fontWeight: '400',
              width: '100%',
              textAlign: 'center',
            }}
          >
            {stepName}
          </span>
        </div>

        <div
          style={{
            width: '100%',
            height: '8px',
            backgroundColor: '#E5E7EB',
            borderRadius: '4px',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              width: `${(stepNumber / 4) * 100}%`,
              height: '100%',
              backgroundColor: '#6A0098',
              borderRadius: '4px',
              transition: 'width 0.3s ease-in-out',
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <div className={styles.container_page}>
      <div className={styles.box_logo}>
        <img src={xamaLogoazul} alt="logo" style={{ height: 40 }} />
      </div>

      <ProgressBar />

      {step === STEPS.STEP_PASS_NICHE_AND_OBJECTIVE && (
        <StepNIcheAndObjective
          setStep={setStep}
          setBusinessAccountData={setBusinessAccountData}
          objectiveSelected={objectiveSelected}
          setObjectiveSelected={setObjectiveSelected}
          changesStep={changesStep}
        />
      )}
      {step === STEPS.STEP_PASS_COLOR_PALETTE && (
        <StepColorPalette
          setStep={setStep}
          colors={colors}
          setColors={setColors}
          businessAccountData={businessAccountData}
          changesStep={changesStep}
        />
      )}
      {step === STEPS.STEP_PASS_TYPOGRAPHY && (
        <StepTypography
          setStep={setStep}
          businessAccountData={businessAccountData}
          font={font}
          setFont={setFont}
          changesStep={changesStep}
        />
      )}
      {step === STEPS.STEP_PASS_LOGO && (
        <StepLogo
          setStep={setStep}
          logoSelectedArray={logoSelectedArray}
          setLogoSelectedArray={setLogoSelectedArray}
          changesStep={changesStep}
        />
      )}
    </div>
  );
}

export default FastPublishing1;
